import React, { Component } from "react";
import FetchServerData from "../../../provider/FetchServerData";
import { PledgeThermometer_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
class LaunchTickerOverlay extends Component {
  constructor(props) {
    super(props);
    const str = new URLSearchParams(window.location.search);
    const urlTid = str.get("t");
    const pledgeId = str.get("p");
    this.state = {
      bannerText: "",
      bannerTextColor: "#ffffff",
      bannerBackground: "#353538",
      urlTid: urlTid,
      pledgeId: pledgeId,
      donationList: [],
      render: false,
    };
    // this.getThermometerDetails(urlTid, pledgeId);
  }

  componentDidMount() {
    this.getThermometerDetails(this.state.urlTid, this.state.pledgeId);
    this.timerId = setInterval(
      () => this.getThermometerDetails(this.state.urlTid, this.state.pledgeId),
      10000
    );
  }

  duplicateListContinuously() {
    // dynamically duplicate the list to fill scrolling width
    const list = [...this.state.donationList];
    let repeatedList = [...list];

    // Keep duplicating until long enough for continuous scrolling
    while (repeatedList.length < 50) {
      repeatedList = repeatedList?.concat(list);
    }

    this.setState({ donationList: repeatedList });
  }

  componentWillUnmount() {
    clearInterval(this.timerId);
  }

  getThermometerDetails(urlTid, pledgeId) {
    FetchServerData.callGetServiceWithoutHeader(
      `${PledgeThermometer_Url}/${urlTid}/${pledgeId}`
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let pledgeDetails = output.data.smsMessage?.pledgeDetails;
        let tickerMeterSettings = output.data.smsMessage?.tickerMeterSettings;
        for (let i = 0; i < pledgeDetails.donationList.length; i++) {
          pledgeDetails.donationList[i].amount = Utils.formatWithCommas(
            pledgeDetails.donationList[i].amount
          );
        }

        if (pledgeDetails.bannerText) {
          pledgeDetails.donationList.unshift({
            firstName: pledgeDetails.bannerText,
            isBanner: true, // optional flag to identify it later
          });
        }

        this.setState({
          pledgeId: pledgeDetails.id,
          donationList: pledgeDetails.donationList,
          bannerText: tickerMeterSettings.bannerText,
          bannerTextColor: tickerMeterSettings.bannerTextColor,
          bannerBackground: tickerMeterSettings.bannerBackground,
          render: true,
        });
        this.duplicateListContinuously();
      } else {
      }
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div
            className="authentication-wrapper authentication-cover"
            style={{ textAlign: "center", background: "#39b54a" }}
          >
            <div className="authentication-inner row m-0">
              <div
                className="row d-flex align-items-center m-0"
                style={{
                  position: "absolute",
                  bottom: "15px",
                  width: "100%",
                  overflow: "hidden", // ✅ hide overflow for smooth scroll
                  backgroundColor: this.state.bannerBackground,
                }}
              >
                <div
                  className="scroll-banner-container"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                >
                  <div className="scroll-banner">
                    {this.state.donationList.map((item, index) => (
                      <span
                        key={index}
                        style={{
                          marginRight: "70px",
                          color: this.state.bannerTextColor,
                        }}
                      >
                        {item.isBanner
                          ? item.firstName
                          : item.isShowAnonymous
                            ? "Anonymous"
                            : `${item.firstName} ${item.lastName}`}{" "}
                        {!item.isBanner && `$${item.amount}`}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default LaunchTickerOverlay;
